import { render } from "./FootPrint.vue?vue&type=template&id=4a992e4a&scoped=true"
import script from "./FootPrint.vue?vue&type=script&lang=ts"
export * from "./FootPrint.vue?vue&type=script&lang=ts"

import "./FootPrint.vue?vue&type=style&index=0&id=4a992e4a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a992e4a"

export default script